export default "__VITE_PUBLIC_ASSET__bb5722e1__"